import { FormGroup, Input, OptionType, Select, Text } from '@agro-club/agroclub-shared'
import { debounce } from 'lodash'
import { FormikContextType } from 'formik'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { Contact } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ShortFormControl } from 'views/styled/common'
import { AButton } from 'views/components/Analytics'

type Props = {
  formik: FormikContextType<any>
  parentId?: number
  editMode: boolean
}

const ContactEntry = ({ option }: { option: OptionType }) => {
  return (
    <div>
      <div>{option.dto.phone}</div>
      {option.dto.email && <div>{option.dto.email}</div>}
      <div>{option.dto.fullname}</div>
      {option.dto.position && (
        <Text color="secondary" typography="bodyMedium">
          {option.dto.position}
        </Text>
      )}
    </div>
  )
}
export const ContactsControl = ({ formik, parentId, editMode }: Props) => {
  const { t } = useTranslation('deal')
  const [manualPhoneInput, setManualPhoneInput] = useState(editMode || !parentId)
  const [selectVal, setSelectVal] = useState<string | null>(formik.values.phone)
  const [searchVal, setSearchVal] = useState('')

  const [, contacts = []] = useSingleEntity<Contact[]>(
    !manualPhoneInput && parentId
      ? `${endpoints.companyGroupContacts(parentId.toString())}?search=${searchVal}`
      : undefined,
  )
  const options = useMemo(
    () =>
      contacts.map((c) => ({
        label: c.phone,
        value: c.phone,
        dto: c,
      })),
    [contacts],
  )
  //const options = []
  const onSearch = (searchValue = '') => {
    if (searchVal !== searchValue) {
      setSearchVal(searchValue)
    }
  }

  const debouncedOnSearch = debounce(onSearch, 500)

  if (manualPhoneInput) {
    return (
      <ShortFormControl>
        <FormGroup label={t('requestDocsModal.phone')} error={formik.errors.phone} required>
          <Input
            {...formik.getFieldProps('phone')}
            placeholder={t('common:phone_placeholder')}
            invalid={!!formik.errors.phone}
          />
        </FormGroup>
      </ShortFormControl>
    )
  }
  const onChange = (val: string) => {
    setSelectVal(val)
    if (!val) {
      formik.setFieldValue('phone', '')
      return
    }
    const found = contacts.find((c) => c.phone === val)
    if (!found) return
    formik.setFieldValue('phone', found.phone)
    formik.setFieldValue('email', found.email)
  }
  if (manualPhoneInput) {
    return
  }

  const notFound = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {t('contactNotFound')}
      <AButton id="manualPhone" onClick={() => setManualPhoneInput(true)}>
        {t('manualInput')}
      </AButton>
    </div>
  )

  return (
    <>
      <FormGroup required label={t('requestDocsModal.phone')}>
        <Select
          OptionComponent={ContactEntry}
          options={options}
          onSearch={debouncedOnSearch}
          optionLabelProp="value"
          onChange={onChange}
          value={selectVal}
          allowClear={false}
          fullWidth
          notFoundContent={notFound}
        />
      </FormGroup>
    </>
  )
}
